import React, { Fragment } from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { Card } from '../../../../../../shared/card/card'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { IconEdit } from '../../../../../../shared/icon/icon'
import { FolderMenu } from '../../common/menu/node-actions'
import { ThumnailAsset } from '../../common/thumbnail/thumbnail-asset'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'
import { useRoleOrgNode } from '../../../../../../role/hook/role-org'
import { Route } from 'react-router-dom/cjs/react-router-dom.min'
import { PublishAssetList } from '../../common/publish/publish-asset-list'

export const NodeCategoryEdit = ({ parentURL, nodeID, useApiForm, dataContext, section }) => {
  const apiForm = useApiForm()

  const roleOrgNode = useRoleOrgNode()

  const handleMatch = () => apiForm.get(nodeID)

  const handleSubmit = async data => {
    await apiForm.put(data.id, data)
    dataContext.reload()
  }

  const handleChange = () => dataContext.reload()

  const HeaderMenu = () => <FolderMenu place="header" url={parentURL} nodeID={nodeID} section={section} />

  return (
    <Fragment>
      {/* File versions is the node's menu page, mounted under this address:
          it is no page of Edit's (audit F16). */}
      <BreadcrumbView Icon={IconEdit} text="Edit" onMatch={handleMatch} notOver={['publishes']}>
        <CardFullHeightScrollY title={apiForm.form.name} HeaderMenu={HeaderMenu}>
          <Card>
            <FormSimple state={apiForm.form} disabled={!roleOrgNode.accessUpdate} onRefresh={handleMatch} onSubmit={handleSubmit}>
              <FormSimpleText name="name" />
              <FormSimpleSubmitEdit backURL={parentURL} />
            </FormSimple>
          </Card>

          {/* <NodeTags apiForm={apiForm} /> */}

          <ThumnailAsset nodeID={nodeID} onChange={handleChange} />
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${parentURL}/edit/publishes`}>
        <PublishAssetList nodeID={nodeID} />
      </Route>
    </Fragment>
  )
}
